module.exports = __webpack_public_path__ + "img/sprite.ceb47bee.svg";